<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Data Mart Details
          </div>
        </template>
        <template #actions>
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button" tabindex="0" @keyup.enter="resynchDatamart()"
                  @click="resynchDatamart()"
                  style="font-size: smaller;margin-top: 0.2rem">
                  Re&#8209;Synch
                </a>
              </div>
            </li>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button" tabindex="0" @keyup.enter="refreshDataMart()"
                  @click="refreshDataMart()">
                  <font-awesome-icon
                    :icon="['fas', 'sync-alt']"
                    size="lg"
                    title="Refresh" />
                </a>
              </div>
            </li>
            <li class="p-narrow no-border" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
              <div class="list-content">
                <a role="button" tabindex="0" @keyup.enter="editDataMart()"
                  @click="editDataMart()">
                  <font-awesome-icon
                    :icon="['far', 'edit']"
                    size="lg"
                    title="Edit" />
                </a>
              </div>
            </li>
            <li class="p-narrow no-border" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
              <div class="list-content">
                <a role="button" tabindex="0" @keyup.enter="deleteDataMart()"
                  @click="deleteDataMart()">
                  <font-awesome-icon
                    :icon="['far', 'trash-alt']"
                    size="lg"
                    title="Delete" />
                </a>
              </div>
            </li>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button" tabindex="0" @keyup.enter="goBackToAllDataMarts()"
                  @click="goBackToAllDataMarts()">
                  <font-awesome-icon
                    :icon="['far', 'angle-double-left']"
                    size="lg"
                    title="Go Back" />
                </a>
              </div>
            </li>
          </ul>
        </template>
      </es-header>
    </div>
    <div class="content">
      <es-loader v-if="loading" />
      <es-exception v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator." />
      <div v-else>
        <table>
          <tbody>
            <tr>
              <th class="category">
                {{ datamart.label }}
              </th>
            </tr>
            <tr>
              <td class="has-text-grey" style="width: 625px">
                Mart Type
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-static"
                    :value="datamart.datamartType.name" readonly
                    :title="datamart.datamartType.name"
                    aria-label="Mart Type" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Display Name
              </td>
              <td>
                <div class="control">
                  <input class="input"
                    type="text"
                    :class="{ 'is-static': !isEditing, 'is-danger': hasErrorDisplayName }"
                    :readonly="!isEditing"
                    :title="datamart.label"
                     v-model="datamart.label"
                     @keyup.prevent="validateInputField('displayName')"
                     aria-label="Destination Display Name" />
                  <span v-if="hasErrorDisplayName" class="help is-danger">
                    {{ msgDisplayName }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Table Name
              </td>
              <td>
                <div class="control">
                  <input class="input"
                    type="text"
                    :class="{ 'is-static': !isEditing, 'is-danger': hasErrorTableName }"
                    :readonly="!isEditing"
                    v-model="datamart.tableName"
                    :title="datamart.tableName"
                    @keyup.prevent="validateInputField('tableName')"
                    aria-label="Destination Table Name" />
                  <span v-if="hasErrorTableName" class="help is-danger">
                    {{ msgTableName }}
                  </span>
                </div>
              </td>
            </tr>
             <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Driver Name
              </td>
              <td class="text">
                <div class="control">
                  <input class="input" type="text"
                    :class="{ 'is-static': !isEditing, 'is-danger': hasErrorDriverName }"
                    :readonly="!isEditing"
                    v-model="datamart.config.driverName"
                    :title="datamart.config.driverName"
                    @keyup.prevent="validateInputField('driverName')"
                    aria-label="Destination Driver Name" />
                  <span v-if="hasErrorDriverName" class="help is-danger">
                    {{ msgDriverName }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection URL
              </td>
              <td class="text">
                <div class="control">
                  <input class="input" type="text"
                    :class="{ 'is-static': !isEditing, 'is-danger': hasErrorConnectionURL }"
                    :readonly="!isEditing"
                    v-model="datamart.config.url"
                    :title="datamart.config.url"
                    @keyup.prevent="validateInputField('connectionURL')"
                    aria-label="Destination Connection URL" />
                  <span v-if="hasErrorConnectionURL" class="help is-danger">
                    {{ msgConnectionURL }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection Username
              </td>
              <td class="text">
                <div class="control">
                  <input class="input" type="text"
                   :class="{ 'is-static': !isEditing, 'is-danger': hasErrorUserName }"
                    :readonly="!isEditing"
                    v-model="datamart.config.username"
                    :title="datamart.config.username"
                    @keyup.prevent="validateInputField('userName')"
                    aria-label="Destination Connection Username" />
                  <span v-if="hasErrorUserName" class="help is-danger">
                    {{ msgUserName }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection Password
              </td>
              <td class="text">
                <div class="control">
                  <input class="input" type="password" autocomplete="current-password"
                  :class="{ 'is-static': !isEditing, 'is-danger': hasErrorPassword }"
                    :readonly="!isEditing"
                     v-model="datamart.config.password"
                     :title="datamart.config.password"
                    @keyup.prevent="validateInputField('password')"
                    aria-label="Destination Connection Password" />
                  <span v-if="hasErrorPassword" class="help is-danger">
                    {{ msgPassword }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="width: 625px">
                Destination Status
              </td>
              <td class="text">
                <div class="control">
                  <input class="input"
                    :class="{ 'is-static': !isEditing }"
                    type="text"
                    :value="datamart.active === true ? 'Active' : 'Inactive'"
                    :readonly="!isEditing"
                    v-if="!isEditing"
                    aria-label="Destination Status" />
                  <template v-if="isEditing">
                    <button  class="button button--form" v-for="(option, index) in statusOptions"
                      :key="index"
                      @click="datamart.active = option.code"
                      :class="{ 'is-active': datamart.active === option.code }"
                      style="min-width: 100px">
                      {{ option.description }}
                    </button>
                  </template>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Last Synchronization Date
              </td>
              <td class="text">
                <div class="control">
                  <span class="input is-static">{{ datamart.syncTime | formatDate }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Record Count
              </td>
              <td class="text">
                <div class="control">
                    <es-loader v-if="loadingCount" class="small-loader" />
                    <template v-else>
                    <input class="input is-static"
                      :value="datamart.destinationRecordCount" readonly
                      :title="datamart.destinationRecordCount"
                      aria-label="Destination Record Count" />
                    </template>
                  </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Source Record Count
              </td>
              <td class="text">

                  <div class="control">
                    <es-loader v-if="loadingCount" class="small-loader" />
                  <template v-else>
                    <input class="input is-static"
                      :value="datamart.sourceRecordCount" readonly
                      :title="datamart.sourceRecordCount"
                      aria-label="Source Record Count" />
                    </template>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="showModule" class="modal is-active">
      <div class="modal-background" />
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-weight-bold">
            Delete Mart
          </p>
          <button class="delete" aria-label="close"
            @click="closeDeleteModule" />
        </header>
        <section class="modal-card-body">
          <div class="modal-body">
            You cannot recover deleted Data Mart.<br />
            Are you sure you want to delete this Data Mart?
          </div>
          <div class="is-flex flex-justify--end flex-align--center">
            <a role="button" tabindex="0"
              @keyup.enter="closeDeleteModule"
              style="position:relative; right:25px; vertical-align: middle"
              @click="closeDeleteModule">
              Cancel
            </a>
            <button class="button is-primary margin-left" @click="deleteSource()">
              Delete Data Mart
            </button>
          </div>
        </section>
      </div>
    </div>
    <div v-if="isEditing && !loading && !loadingError"
       class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 5.15rem; padding-bottom: 2rem">
      <button class="button button-link has-underline"
        @click.prevent="cancelPanel()"
        style="margin-right: 1rem">
        Cancel
      </button>
      <button class="button is-primary"
        @click.prevent="updateDatamart()">
        Update
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import moment from 'moment';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
  },
  created() {
    this.originalDatamart = JSON.parse(JSON.stringify(this.datamartObject));
    this.statusOptions = [
      {
        code: true,
        description: 'Active',
      },
      {
        code: false,
        description: 'Inactive(Suspended)',
      },
    ];
  },
  mounted() {
    this.getDatamartWithCounts();
  },
  props: {
    datamartObject: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('lookups', [
      'activeDatamartTypes',
    ]),
    preSelectedMartType() {
      return this.activeDatamartTypes.filter(m => m.id === this.datamart.datamartType.id);
    },
  },
  data() {
    return this.initialData();
  },
  methods: {
    initialData() {
      return {
        isEditing: false,
        loading: false,
        loadingCount: false,
        loadingError: false,
        showModule: false,
        hasErrorDisplayName: false,
        hasErrorTableName: false,
        hasErrorDriverName: false,
        hasErrorConnectionURL: false,
        hasErrorUserName: false,
        hasErrorPassword: false,
        msgDisplayName: '',
        msgTableName: '',
        msgDriverName: '',
        msgConnectionURL: '',
        msgUserName: '',
        msgPassword: '',
        datamart: this.datamartObject,
        originalDatamart: null,
      };
    },
    validateInputField(fieldName) {
      const alphanumericRegex = /^[a-zA-Z0-9]+$/;
      const validTableNameRegex = /^[a-zA-Z0-9-_]+$/;
      const maxDisplayNameLength = 100;
      const maxTableNameLength = 100;
      const maxDriverNameLength = 250;
      const maxConnectionURLLength = 250;
      const maxUsernameLength = 50;
      const maxPasswordLength = 50;

      switch (fieldName) {
        case 'displayName':
          this.hasErrorDisplayName = !this.datamart.label;
          this.msgDisplayName = this.hasErrorDisplayName ? 'Destination Display Name is required.' : '';
          if (this.datamart.label
              && this.datamart.label.length > maxDisplayNameLength) {
            this.hasErrorDisplayName = true;
            this.msgDisplayName = `Destination Display Name allows a maximum of ${maxDisplayNameLength} characters.`;
          }
          break;
        case 'tableName':
          this.hasErrorTableName = !this.datamart.tableName;
          this.msgTableName = this.hasErrorTableName ? 'Destination Table Name is required.' : '';

          if (this.datamart.tableName
              && !validTableNameRegex.test(this.datamart.tableName)) {
            this.hasErrorTableName = true;
            this.msgTableName = 'Destination Table Name is invalid.';
          }

          if (this.datamart.tableName
              && this.datamart.tableName.length > maxTableNameLength) {
            this.hasErrorTableName = true;
            this.msgTableName = `Destination Table Name allows a maximum of ${maxTableNameLength} characters.`;
          }
          break;
        case 'driverName':
          this.hasErrorDriverName = !this.datamart.config.driverName;
          this.msgDriverName = this.hasErrorDriverName ? 'Destination Driver Name is required.' : '';

          if (this.datamart.config.driverName
              && this.datamart.config.driverName.length > maxDriverNameLength) {
            this.hasErrorDriverName = true;
            this.msgDriverName = `Destination Driver Name allows a maximum of ${maxDriverNameLength} characters.`;
          }
          break;
        case 'connectionURL':
          this.hasErrorConnectionURL = !this.datamart.config.url;
          this.msgConnectionURL = this.hasErrorConnectionURL ? 'Destination Connection URL is required.' : '';

          if (this.datamart.config.url
              && this.datamart.config.url.length > maxConnectionURLLength) {
            this.hasErrorConnectionURL = true;
            this.msgConnectionURL = `Destination Connection URL allows a maximum of ${maxConnectionURLLength} characters.`;
          }
          break;
        case 'userName':
          this.hasErrorUserName = !this.datamart.config.username;
          this.msgUserName = this.hasErrorUserName ? 'Destination Connection Username is required.' : '';

          if (this.datamart.config.username
              && this.datamart.config.username.length > maxUsernameLength) {
            this.hasErrorUserName = true;
            this.msgUserName = `Destination Connection Username allows a maximum of ${maxUsernameLength} characters.`;
          }

          if (this.datamart.config.username
              && !alphanumericRegex.test(this.datamart.config.username)) {
            this.hasErrorUserName = true;
            this.msgUserName = 'Destination Connection Username is invalid.';
          }
          break;
        case 'password':
          this.hasErrorPassword = !this.datamart.config.password || this.datamart.config.password === '*********';
          this.msgPassword = this.hasErrorPassword ? 'Destination Connection Password is required.' : '';

          if (this.datamart.config.password
              && this.datamart.config.password.length > maxPasswordLength) {
            this.hasErrorPassword = true;
            this.msgPassword = `Destination Connection Password allows a maximum of ${maxPasswordLength} characters.`;
          }
          break;
        default:
          break;
      }
    },
    hasFieldErrors() {
      this.validateInputField('displayName');
      this.validateInputField('tableName');
      this.validateInputField('driverName');
      this.validateInputField('connectionURL');
      this.validateInputField('userName');
      this.validateInputField('password');
      const err = this.hasErrorDisplayName
        || this.hasErrorTableName
        || this.hasErrorDriverName
        || this.hasErrorConnectionURL
        || this.hasErrorUserName
        || this.hasErrorPassword;

      if (err) {
        this.showNotification('danger', ['There were some errors.Please fix the errors highlighted in the fields below.']);
      } else {
        this.hideNotification();
      }

      return err;
    },
    cancelPanel() {
      // Reset the `datamart` object with the original values
      this.datamart = JSON.parse(JSON.stringify(this.originalDatamart));
      this.resetFormErrors();
      this.hideNotification();
      this.isEditing = false;
    },
    closeDeleteModule() {
      this.showModule = false;
    },
    deleteDataMart() {
      this.showModule = true;
    },
    refreshDataMart() {
      this.getDatamartWithCounts();
    },
    async getDatamartWithCounts() {
      const response = await this.loadDatamart(this.datamart.id);
      this.$set(this.datamart, 'sourceRecordCount', response.data.sourceRecordCount);
      this.$set(this.datamart, 'destinationRecordCount', response.data.destinationRecordCount);
      this.originalDatamart = JSON.parse(JSON.stringify(this.datamart));
    },
    async loadDatamart(id) {
      try {
        this.loadingCount = true;
        this.loadingError = false;
        return await axios.get(`datamart/destination/${id}`);
      } catch (error) {
        this.loadingError = true;
        this.showNotification('danger', [`Error loading count for datamart ID: ${this.datamart.id} - ${error.message}`]);
        return null;
      } finally {
        this.loadingCount = false;
      }
    },
    async deleteSource() {
      try {
        await axios.delete(`datamart/destination/${this.datamart.id}`);
        this.showNotification('success', ['The Data Mart been deleted successfully.']);
        this.showModule = false;
        this.goBackToAllDataMarts();
      } catch (error) {
        if (error.response.status === 400) {
          this.apiMsg = 'There was an issue. Please try again or contact your administrator.';
        } else {
          this.apiMsg = 'There were some errors. Please fix the errors highlighted in the fields below.';
        }
        this.showNotification('danger', [this.apiMsg]);
      }
    },
    editDataMart() {
      this.isEditing = true;
    },
    goBackToAllDataMarts() {
      this.$emit('dataMartList');
    },
    resynchDatamart() {
      this.$emit('resynchDatamartDetails', this.datamartObject);
    },
    resetFormErrors() {
      // Reset all the form validation errors
      this.hasErrorDisplayName = false;
      this.hasErrorTableName = false;
      this.hasErrorDriverName = false;
      this.hasErrorConnectionURL = false;
      this.hasErrorUserName = false;
      this.hasErrorPassword = false;
      this.hasErrorMartType = false;
      this.msgMartType = '';
      this.msgDisplayName = '';
      this.msgTableName = '';
      this.msgDriverName = '';
      this.msgConnectionURL = '';
      this.msgUserName = '';
      this.msgPassword = '';
    },
    async updateDatamart() {
      if (this.hasFieldErrors()) return;
      try {
        const config = {
          driverName: this.datamart.config.driverName,
          url: this.datamart.config.url,
          username: this.datamart.config.username,
          password: this.datamart.config.password,
        };
        const data = {
          // Construct the data object with the input values
          typeId: this.datamart.id,
          active: this.datamart.active,
          label: this.datamart.label,
          tableName: this.datamart.tableName,
          config: JSON.stringify(config), // Serialize the config object as a JSON string
        };
        await axios.put(`datamart/destination/${this.datamart.id}`, data);
        this.showNotification('success', ['The Data Mart Details have been updated successfully.']);
        this.isEditing = false;
        this.goBackToAllDataMarts();
      } catch (error) {
        if (error.response.status === 400) {
          this.apiMsg = `Error Updating datamart: ${error.response.data.message}`;
        } else {
          this.apiMsg = 'There was an issue. Please try again or contact your administrator.';
        }
        this.showNotification('danger', [this.apiMsg]);
      }
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY HH:mm:ss');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    font-size: 12px
    vertical-align: middle
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  .category
    padding-top: 1.5rem
    border: 0
  .content
    padding: 0 3rem 0.5rem
  .header
    display: flex
    align-items: center
  .modal-body
    margin-bottom: 1rem
    display: flex
    text-align: left
    justify-content: flex-start
  .modal-card-head
    padding: 8px 16px
  .modal-card-title
    display: flex
    font-size: 15.2px
  .no-border
    border: 0
  .rule
    font-size: 12px
    color: #666
  .text
    text-align: center
    font-size: 14px
  .small-loader
    width: 20px;
    height: 20px;
  .content
    overflow-x: auto
  .control input
    text-overflow: ellipsis
</style>
